import Bell from '@/app/_components/ui/icons/Bell.svg';
import React, { useState } from 'react';
import { useSession, signIn } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { useUpdateInformCustomer } from '@/app/_hooks/useCustomerInform';
import { usePathname } from 'next/navigation';

export default function SpInformCustomer({ token, id }) {
  const { data: session } = useSession();
  const isUser = !!session?.user;
  const router = useRouter();
  const pathname = usePathname();
  const updateCustomerInform = useUpdateInformCustomer();
  const [buttonText, setButtonText] = useState('موجود شد به من اطلاع بده');

  const addUsertToPanedingList = () => {
    if (!isUser) {
      router.push(`/users/login?callbackUrl=${encodeURIComponent(pathname)}`);
    } else {
      updateCustomerInform.mutate(
        { token, id },
        {
          onSuccess: async () => {
            setButtonText('درخواست شما با موفقیت ثبت شد');
          },
        }
      );
    }
  };
  return (
    <div
      className={`w-full hover:shadow-primary cursor-pointer flex justify-center items-center transition  bg-color-primary text-white py-3 rounded-md text-sm SpAddTocartButton 
      
    `}
      onClick={addUsertToPanedingList}
    >
      <div className="flex text-center justify-center items-center px-4 ">
        <span className="w-9">
          <Bell />
        </span>
        <span className=""> {buttonText}</span>
      </div>
    </div>
  );
}
